if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          this.syncOtherPickers(event.target);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      syncOtherPickers(changedInput) {
        const sectionId = this.dataset.section;
        const optionValueId = changedInput.dataset?.optionValueId;
        if (!optionValueId) return;

        // Find all other variant-selects for the same section
        const allPickers = document.querySelectorAll(`variant-selects[data-section="${sectionId}"]`);

        allPickers.forEach(picker => {
          if (picker === this) return; // Skip self

          // Find the matching input by option-value-id
          const matchingInput = picker.querySelector(`input[data-option-value-id="${optionValueId}"]`);
          if (matchingInput && !matchingInput.checked) {
            matchingInput.checked = true;
            // Update the visual label
            const label = matchingInput.closest('.product-form__input')?.querySelector('[data-selected-swatch-value]');
            if (label) {
              label.textContent = changedInput.value;
            }
            // Update checked-lab class for button style
            const allLabels = matchingInput.closest('fieldset')?.querySelectorAll('.label-variant');
            if (allLabels) {
              allLabels.forEach(l => l.classList.remove('checked-lab'));
              const matchingLabel = picker.querySelector(`label[for="${matchingInput.id}"]`);
              if (matchingLabel) matchingLabel.classList.add('checked-lab');
            }
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
